// src/features/statistics/types/demographics-filter.ts

export type DemographicsFilter = {
  countries: string[];
  cities: string[];
  gender: 'M' | 'F' | null;
  ageRanges: string[];
};

export const AGE_RANGES = [
  '13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+',
] as const;

export type AgeRange = typeof AGE_RANGES[number];

export const EMPTY_FILTER: DemographicsFilter = {
  countries: [],
  cities: [],
  gender: null,
  ageRanges: [],
};

export function isFilterEmpty(f: DemographicsFilter): boolean {
  return f.countries.length === 0 && f.cities.length === 0 && !f.gender && f.ageRanges.length === 0;
}

export function countActiveFilters(f: DemographicsFilter): number {
  return [
    f.countries.length > 0,
    f.cities.length > 0,
    f.gender !== null,
    f.ageRanges.length > 0,
  ].filter(Boolean).length;
}
